
/**
 * 스트리밍 상태
 */
export type GetStreamingInfoByPath200Status = typeof GetStreamingInfoByPath200Status[keyof typeof GetStreamingInfoByPath200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfoByPath200Status = {
  ready: 'ready',
  processing: 'processing',
  error: 'error',
} as const;
